// Component for creating an outfit
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const CreateOutfit = () => {
    const [clothes, setClothes] = useState([]);
    const [selectedClothes, setSelectedClothes] = useState([]);
    const [outfitName, setOutfitName] = useState('');
    const [occasions, setOccasions] = useState('');
    const navigate = useNavigate();

    // Search state variables
    const [clothNameSearchTerm, setClothNameSearchTerm] = useState('');
    const [categorySearchTerm, setCategorySearchTerm] = useState('');
    const [colorSearchTerm, setColorSearchTerm] = useState('');
    const [seasonSearchTerm, setSeasonSearchTerm] = useState('');

    useEffect(() => {
        fetchClothes(); // Fetch clothes when component loads
    }, []);

    const fetchClothes = async () => {
        try {
            const response = await axios.get('http://localhost:3000/api/clothes', {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            setClothes(response.data);
        } catch (error) {
            console.error('Error fetching clothes:', error.response ? error.response.data : error.message);
        }
    };

    const handleClothSelect = (clothId) => {
        setSelectedClothes((prevSelected) =>
            prevSelected.includes(clothId)
                ? prevSelected.filter((id) => id !== clothId)
                : [...prevSelected, clothId]
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const outfitData = {
            outfit_name: outfitName,
            occasion: occasions.split(',').map(occ => occ.trim()),
            clothing_items: selectedClothes
        };
    
        try {
            await axios.post('http://localhost:3000/api/outfits', outfitData, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            navigate('/outfits');  // Redirect to Outfits page after creation
        } catch (error) {
            console.error('Error creating outfit:', error.response ? error.response.data : error.message);
            alert('Error creating outfit. Please try again.');
        }
    };

    // Filter clothes based on search terms
    const filteredClothes = clothes.filter(cloth => {
        const matchesClothName = cloth.cloth_name.toLowerCase().includes(clothNameSearchTerm.toLowerCase());
        const matchesCategory = cloth.category.some(cat => cat.toLowerCase().includes(categorySearchTerm.toLowerCase()));
        const matchesColor = cloth.color.some(col => col.toLowerCase().includes(colorSearchTerm.toLowerCase()));
        const matchesSeason = cloth.season.some(sea => sea.toLowerCase().includes(seasonSearchTerm.toLowerCase()));

        return matchesClothName && matchesCategory && matchesColor && matchesSeason;
    });    

    return (
        <div className="create-outfit-container">
            <h1 className="form-title"><strong>𝒞𝓇𝑒𝒶𝓉𝑒 𝒶𝓃 𝒪𝓊𝓉𝒻𝒾𝓉</strong></h1>
            <form onSubmit={handleSubmit}>
                <label>
                    <strong>Outfit Name:</strong>
                    <input
                        type="text"
                        value={outfitName}
                        onChange={(e) => setOutfitName(e.target.value)}
                        placeholder="Enter outfit name"
                        required
                    />
                </label>
                <label>
                    <strong>Activity\-ies:</strong>
                    <input
                        type="text"
                        value={occasions}
                        onChange={(e) => setOccasions(e.target.value)}
                        placeholder="e.g. Coffee, Gym (separate with commas)"
                        required
                    />
                </label>
                <div className="search-filters">
                    <h4><strong>𝒮𝑒𝒶𝓇𝒸𝒽 & 𝒮𝑒𝓁𝑒𝒸𝓉 𝒞𝓁𝑜𝓉𝒽𝑒𝓈:</strong></h4>
                    <input
                        type="text"
                        placeholder="Search by cloth name"
                        value={clothNameSearchTerm}
                        onChange={(e) => setClothNameSearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by category"
                        value={categorySearchTerm}
                        onChange={(e) => setCategorySearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by color"
                        value={colorSearchTerm}
                        onChange={(e) => setColorSearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by season"
                        value={seasonSearchTerm}
                        onChange={(e) => setSeasonSearchTerm(e.target.value)}
                    />
                </div>
                <div className="clothing-list">
                    {filteredClothes.map((cloth) => (
                        <div
                            key={cloth._id}
                            className={`clothing-item ${selectedClothes.includes(cloth._id) ? 'selected' : ''}`}
                            onClick={() => handleClothSelect(cloth._id)}
                        >
                            <img src={cloth.image_url} alt={cloth.cloth_name} />
                            <label>{cloth.cloth_name}</label>
                        </div>
                    ))}
                </div>
                <button type="submit" className="update-btn"><i className="fa-solid fa-plus"></i> <strong>𝒞𝓇𝑒𝒶𝓉𝑒</strong></button>
            </form>
        </div>
    );
};

export default CreateOutfit;